export default "__VITE_ASSET__BDGZJFz4__"